/* ==========================================================================
   HOME PASSION · emniyet katmani
   IntersectionObserver / requestAnimationFrame kisilirsa icerik gorunmez
   kalmasin, karusel kilitlenmesin. Kaydirmaya bagli, rAF'siz yedek.
   ========================================================================== */
(function(){
  'use strict';

  function revealVisible(){
    var h = window.innerHeight || 800;
    document.querySelectorAll('.hp-rv:not(.in), .hp-stagger:not(.in)').forEach(function(e){
      var r = e.getBoundingClientRect();
      if(r.top < h * 1.15 && r.bottom > -200){ e.classList.add('in'); }
    });
  }

  /* Karuseller: giris animasyonu ve snap her kosulda acilsin */
  function unlockCarousels(){
    document.querySelectorAll('.hp-crsl-in').forEach(function(vp){
      vp.classList.add('enter');
      vp.classList.add('live');
    });
  }

  var t = null;
  function onScroll(){
    if(t) return;
    t = setTimeout(function(){ t = null; revealVisible(); }, 120);
  }

  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll, {passive:true});
  addEventListener('load', function(){ revealVisible(); unlockCarousels(); });
  document.addEventListener('shopify:section:load', function(){ revealVisible(); unlockCarousels(); });

  revealVisible();
  [300, 900, 2000, 4000].forEach(function(ms){ setTimeout(revealVisible, ms); });
  [1500, 3000].forEach(function(ms){ setTimeout(unlockCarousels, ms); });
})();
